import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAYDWzh54J0Jg-f4wnq63m-3gCsnui9Rvc",
  authDomain: "ioseaplethora.firebaseapp.com",
  databaseURL: "https://ioseaplethora.firebaseio.com",
  projectId: "ioseaplethora",
  storageBucket: "ioseaplethora.appspot.com",
  messagingSenderId: "1010925304230",
  appId: "1:1010925304230:web:9a72345a425286676df767",
  measurementId: "G-EQLMFQ6B1W"
};

const firebaseApp = initializeApp(firebaseConfig);
const projectAuth = getAuth(firebaseApp);

setPersistence(projectAuth, browserLocalPersistence);

export { firebaseApp, projectAuth };
